<template>
    <v-sheet class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 as-box-title as-bg-color-100"
        elevation="4" height="150" rounded max-width="600" width="100%" mb="6">
        <div>
            <div class="text-h5 font-weight-medium pa-2">
                DIRECCIÓN GENERAL LOGÍSTICA<br>UNIDAD DE MATERIAL BÉLICO
            </div>
            <p class="text-body-2 mb-4">
                Registro clasificado de armas de fuego, municiones y explosivos de uso Militar
            </p>
            <p class="">Dotación Indidividual</p>
        </div>
    </v-sheet>

    <div class="mx-5 my-5">
        <v-card>
            <v-container>
                <v-card-title>
                    <v-text-field v-model="search" append-icon="mdi-magnify" color="light-blue-darken-4" label="Buscar"
                        single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="dotaciones" :search="search">
                </v-data-table>
            </v-container>
        </v-card>
    </div>
</template>
  
<script>
import DotacionIndividual from "@/services/DotacionIndividual"; // Asegúrate de proporcionar la ruta correcta
import { VDataTable } from 'vuetify/labs/VDataTable'


export default {
    components: {
        VDataTable
    },
    data() {
        return {
            dotaciones: [],
            search: "",
            headers: [
                { title: "Marca", value: "marca" },
                { title: "Nro Pistola", value: "nro_pistola" },
                { title: "Gestión Dotación", value: "gestion_dotacion" },
                { title: "Procedencia", value: "procedencia" },
                { title: "Num. Cargadores", value: "num_cargadores" },
                { text: "Observaciones", value: "observaciones" },
            ],
        };
    },
    methods: {
        async cargarDotaciones() {
            const dotacionService = new DotacionIndividual();
            try {
                this.dotaciones = await dotacionService.index();
                console.log("Dotaciones cargadas:", this.dotaciones);
            } catch (error) {
                console.error("Error al cargar dotaciones:", error);
            }
        },
    },
    created() {
        this.cargarDotaciones();
    },
};
</script>
  